<template>
	<div class="subWrap">
		<DcHeader :title="'资质证照'" />
		<div class="paperBox">
			<div class="paperCell" v-for="(item, index) in imageList" :key="index">
				<div class="img-desc">
					<div>
						{{ item.licenceTypeName }} {{ item.licenceCode && ':' }}
						<span v-html="replaceStr(item.licenceCode)"></span>
					</div>
				</div>
				<div v-for="(src, i) in item.licenceUrlList" :key="i">
					<img :alt="item.licenceTypeName + '-' + item.licenceCode" class="cellImg" :src="compPic(src)" />
				</div>
			</div>
		</div>

		<SubFoot />
	</div>
</template>

<script setup>
import { ref, computed } from 'vue';
import { useRoute } from 'vue-router';
import { queryWebsiteByCompanyId } from '@/api/index';
import { getLicenseByCompanyId } from '@/api/user';
import DcHeader from '@/components/DcHeader.vue';
import SubFoot from '@/components/SubFoot.vue';

const route = useRoute();
const companyId = ref(route.params.companyId || '');
const companyInfo = ref({});
const imageList = ref([]);

const config = useRuntimeConfig();
const pcBase = (config.public.publicPcUrl || '').replace(/\/$/, '');

if (companyId.value && route.path === `/${companyId.value}/certification`) {
	await navigateTo(`/${companyId.value}/certification.html`, { redirectCode: 301, replace: true });
}

useHead(() => {
	const cid = route.params?.companyId;
	const href = pcBase && cid ? `${pcBase}/${cid}/certification.html` : null;
	return {
		link: href ? [{ rel: 'canonical', href }] : [],
	};
});

// SSR 数据获取
const { data: websiteData } = await useAsyncData(`certification-website-${companyId.value}`, () => queryWebsiteByCompanyId(companyId.value));

if (websiteData.value?.data) {
	companyInfo.value = websiteData.value.data;
}

const { data: licenseData } = await useAsyncData(`certification-license-${companyId.value}`, () =>
	getLicenseByCompanyId({ companyId: companyId.value })
);

if (licenseData.value?.code == 200 && licenseData.value?.data) {
	imageList.value = licenseData.value.data;
}

// SEO Meta - 使用SSR获取的数据
const pageTitle = computed(() => {
	const companyFullName = companyInfo.value?.companyName || companyInfo.value?.websiteName || '';
	return `资质证照 - ${companyFullName}`;
});

const pageDescription = computed(() => {
	const companyFullName = companyInfo.value?.companyName || companyInfo.value?.websiteName || '';
	const provinceText = companyInfo.value?.province || '';
	return `${companyFullName}是国药器械在${provinceText}设立的官方分子公司，运营国械在线官方子站。本页公示${companyFullName}的《医疗器械经营许可证》、《营业执照》等医疗器械相关合规资质证照。`;
});

const pageKeyword = computed(() => {
	const companyFullName = companyInfo.value?.companyName || companyInfo.value?.websiteName || '';
	return `医疗器械注册证,医疗器械备案凭证,经营许可证,${companyFullName}`;
});

useSeoMeta({
	title: pageTitle,
	ogTitle: pageTitle,
	description: pageDescription,
	ogDescription: pageDescription,
	keywords: pageKeyword,
	ogImage: 'https://uat-cmdc.oss-cn-beijing.aliyuncs.com/productFile/2022/08/18/9af2756f-27bf-4d1e-b0d1-8397e82bb2a0.png',
});

const replaceStr = str => {
	return str && str.replace(/[,].+;/g, '，').replace(/[,].+$/g, '');
};

const compPic = src => src; // 如有图片前缀处理可在此补充
</script>

<style lang="scss" scoped>
.img-desc {
	margin-bottom: 12px;
}
.subWrap {
	padding-bottom: calc(4.17rem + env(safe-area-inset-bottom));

	.paperBox {
		border-radius: 0.83rem;
		background: #fff;
		margin: 1rem 0.875rem 0 0.875rem;
		padding: 1.25rem 1.92rem 0 2.25rem;

		.paperTitle {
			font-size: 1.33rem;
			font-family: NotoSansSC-Medium, NotoSansSC;
			font-weight: 500;
			color: #222222;
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin-bottom: 1.17rem;

			.rightBtn {
				display: flex;
				align-items: center;
				font-size: 1rem;
				font-family: NotoSansSC-Medium, NotoSansSC;
				font-weight: 500;
				color: #7f90f5;

				.iconfont {
					font-size: 1rem;
					line-height: 1.5rem;
					margin-right: 0.67rem;
				}
			}
		}

		.paperCell {
			width: 100%;
			margin-bottom: 1.67rem;
			padding-bottom: 1.67rem;
			border-bottom: 0.1rem solid #c4c6c9;

			.cellImg {
				width: 100%;
			}
		}

		.paperCell:nth-last-child(1) {
			border-bottom: 0;
		}
	}
}
</style>
